import { GET_ELKASO_USERS, GET_ELKASO_USERS_FAILED, SET_LOADING_STATUS } from 'redux/types';

const INIT_STATE = {
  elkasoUsersList: [],
  isLoading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_LOADING_STATUS:
      return { ...state, isLoading: action.payload };
    case GET_ELKASO_USERS:
      return { ...state, elkasoUsersList: action.payload, isLoading: false };
    case GET_ELKASO_USERS_FAILED:
      return { ...state, elkasoUsersList: [], isLoading: false };
    default:
      return { ...state };
  }
};
